import { useFieldArray, useFormContext } from "react-hook-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "../../../Form/TextField";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  CALLOUTS_PLACEHOLDER,
  CALLOUT_TEXT_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_GOOGLE_CALL_OUT_MAX_LENGTH,
  BORDER_RADIUS,
} from "../../../../utils/constants";
import ChipOptional from "../../../Chip/ChipOptional";

const CalloutsContainer = ({
  name = "callOuts",
  label = CALLOUTS_PLACEHOLDER,
  disabled = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });
  const { t } = useTranslationApp();

  return (
    <Box sx={{ pt: 0 }} id={name}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: "semibold", fontSize: "18px" }}
        >
          {t(label)}
        </Typography>
        <ChipOptional />
      </Box>

      {fields.map((field, index) => (
        <>
          <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
            {`${t(CALLOUT_TEXT_PLACEHOLDER)} ${index + 1}`}
          </Typography>
          <Grid container spacing={2} key={field.id} alignItems="center">
            <Grid item xs={12}>
              <Box sx={{ position: "relative" }}>
                <TextField
                  sx={{
                    height: "72px",
                    width: "100%",
                  }}
                  name={`${name}[${index}].value`}
                  variant="filled"
                  fullWidth
                  control={control}
                  errors={errors}
                  showCounterCharacters={true}
                  maxCharacters={ADS_CAMPAIGN_GOOGLE_CALL_OUT_MAX_LENGTH}
                  disabled={disabled}
                />
                {!disabled && (
                  <IconButton
                    onClick={() => remove(index)}
                    type="button"
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      ))}

      {fields.length < 10 && !disabled && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <IconButton
            onClick={() => append({ value: "" })}
            type="button"
            sx={{
              width: "100%",
              backgroundColor: "transparent",
              fontSize: "14px",
              color: "#FFF",
              border: "1px solid #000",
              borderRadius: BORDER_RADIUS,
              "&:hover": {
                color: "#FFF",
                backgroundColor: "transparent",
              },
            }}
          >
            <AddIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default CalloutsContainer;
